import { render } from "./Time.vue?vue&type=template&id=2dd1c342"
import script from "./Time.vue?vue&type=script&lang=js"
export * from "./Time.vue?vue&type=script&lang=js"
script.render = render

export default script